export class BaseConst {
    static ID = 'ID';
    static Name = 'Name';
    static Code = 'Code';

    // 标签
    static BeLabel = 'BeLabel';
}
